import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl';

// Set default locale
flatpickr.localize(Dutch);

const SELECTOR = '.js-datepicker';

const DEFAULT_CONFIG = {
    dateFormat: 'd/m/Y',
    allowInput: true,
    wrap: true,
    prevArrow:
        // eslint-disable-next-line max-len
        '<svg viewBox="0 0 12 32"><path d="M0.263 15.469l9.175-9.25c0.294-0.294 0.769-0.294 1.063 0l1.238 1.237c0.294 0.294 0.294 0.769 0 1.063l-7.406 7.481 7.406 7.481c0.294 0.294 0.294 0.769 0 1.063l-1.238 1.238c-0.294 0.294-0.769 0.294-1.063 0l-9.175-9.25c-0.294-0.294-0.294-0.769 0-1.063z"></path></svg>',
    nextArrow:
        // eslint-disable-next-line max-len
        '<svg viewBox="0 0 12 32"><path d="M11.738 16.531l-9.175 9.25c-0.294 0.294-0.769 0.294-1.063 0l-1.238-1.238c-0.294-0.294-0.294-0.769 0-1.063l7.406-7.481-7.406-7.481c-0.294-0.294-0.294-0.769 0-1.063l1.238-1.237c0.294-0.294 0.769-0.294 1.062 0l9.175 9.25c0.294 0.294 0.294 0.769 0 1.063z"></path></svg>',
};

function initDatePickers() {
    const DATE_PICKER_NODES = [...document.querySelectorAll(SELECTOR)];

    DATE_PICKER_NODES.forEach((datepickerNode) => {
        initDatePicker(datepickerNode);
    });
}

function initDatePicker(node) {
    flatpickr(node, DEFAULT_CONFIG);
}

export { initDatePickers };
